import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-export-excel-button',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './export-excel-button.component.html',
  styleUrls: ['./export-excel-button.component.css']
})
export class ExportExcelButtonComponent {
  @Input() text: string = 'Exportar Excel';
  @Input() disabled: boolean = false;
  @Input() icon: string = 'file_download';
  
  @Output() exportClick = new EventEmitter<void>();

  onExportClick(): void {
    if (!this.disabled) {
      this.exportClick.emit();
    }
  }
}